import React from 'react';
import './Badge.css';

const Badge = ({ type, size = 'medium' }) => {
  const normalizedType = (type || '').toUpperCase();
  
  const badgeConfig = {
    // Softened labels (current)
    FAVORABLE: { label: 'Favorable', className: 'badge-buy', icon: '↑' },
    PROMISING: { label: 'Promising', className: 'badge-scale', icon: '↗' },
    NEUTRAL: { label: 'Neutral', className: 'badge-watch', icon: '◉' },
    CAUTIOUS: { label: 'Cautious', className: 'badge-hold', icon: '◆' },
    UNFAVORABLE: { label: 'Unfavorable', className: 'badge-pass', icon: '↓' },
    // Legacy labels (backward compatibility)
    BUY: { label: 'Favorable', className: 'badge-buy', icon: '↑' },
    WATCH: { label: 'Neutral', className: 'badge-watch', icon: '◉' },
    PASS: { label: 'Cautious', className: 'badge-pass', icon: '↓' },
    HOLD: { label: 'Neutral', className: 'badge-hold', icon: '◆' },
    TRIM: { label: 'Unfavorable', className: 'badge-trim', icon: '↘' },
    SCALE: { label: 'Favorable', className: 'badge-scale', icon: '↗' },
    AVOID: { label: 'Unfavorable', className: 'badge-avoid', icon: '✕' },
  };

  const config = badgeConfig[normalizedType] || { 
    label: normalizedType, 
    className: 'badge-default',
    icon: '•'
  };

  return (
    <span className={`badge ${config.className} badge-${size}`}>
      <span className="badge-icon">{config.icon}</span>
      <span className="badge-label">{config.label}</span>
    </span>
  );
};

export default Badge;
